import React, { useState, useEffect } from 'react';
import { Table, Button, Card, Container } from 'react-bootstrap';
import { FaDownload } from 'react-icons/fa';
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import { viewImage } from '../../CommonUtils/viewImage';

export default function FirstLevelInspPreviewForShiftingPreview({ collCode, nocType, name, type }) {
    console.log("type", type, "noctype", nocType, "collcode", collCode)

    const apiCond = (type === "physical" || name === "phase2") ? "getShiftingScrutinyDetailsphysical" : "getShiftingScrutinyDetails"
    const [loading, setLoading] = useState(false);
    const [scrutinyData, setScrutinyData] = useState(null);
    const [shiftingData, setShiftingData] = useState(null);
    const [accommodationData, setAccommodationData] = useState([]);
    const [surveyData, setSurveyData] = useState({});
    const [deficiencies, setDeficiencies] = useState([]);
    const [infrastructureDocuments, setInfrastructureDocuments] = useState([]);

    // Additional data from CollegeReport
    const [ugCourses, setUgCourses] = useState([]);
    const [pgCourses, setPgCourses] = useState([]);
    const [corpusFundInstall, setCorpusFundInstall] = useState([]);
    const [ugCorpusFunds, setUgCorpusFunds] = useState([]);
    const [pgBeforeCorpus, setPgBeforeCorpus] = useState([]);
    const [pgAfterCorpus, setPgAfterCorpus] = useState([]);
    const [apiValues, setApiValues] = useState({});
    const [leasedData, setLeasedData] = useState({});

    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        if (collCode) {
            fetchAllData();
        }
    }, [collCode]);
    useEffect(() => {
        if (scrutinyData && Object.keys(apiValues).length > 0) {
            setTableData(buildTableRows(scrutinyData));
        }
    }, [scrutinyData, apiValues, surveyData, leasedData]);

    const fetchAllData = async () => {
        setLoading(true);
        try {
            // 1. Get Shifting Scrutiny Details
            const scrutinyRes = await CommonAxiosGet(`${config.url.FAC_URL}${apiCond}/${collCode}`);
            // if (name === "phase1") {
            //     scrutinyRes = await CommonAxiosGet(`${config.url.FAC_URL}getShiftingScrutinyDetails/${collCode}`);
            // }
            // else {
            //     scrutinyRes = await CommonAxiosGet(`${config.url.FAC_URL}getShiftingScrutinyDetailsphysical/${collCode}`);
            // }


            if (scrutinyRes?.data?.status === true) {
                const data = Array.isArray(scrutinyRes.data.data) ? scrutinyRes.data.data[0] : {};
                setScrutinyData(data);
                setDeficiencies(scrutinyRes.data.def || []);
                setAccommodationData(Array.isArray(scrutinyRes?.data?.AfflAccomData) ? scrutinyRes.data.AfflAccomData : []);
                // Set additional data
                setUgCourses(Array.isArray(scrutinyRes.data.ugCourses) ? scrutinyRes.data.ugCourses : []);
                setPgCourses(Array.isArray(scrutinyRes.data.pgCourses) ? scrutinyRes.data.pgCourses : []);
                setCorpusFundInstall(Array.isArray(scrutinyRes.data.corpusFundInstall) ? scrutinyRes.data.corpusFundInstall : []);

                // Corpus fund data
                const corpusData = Array.isArray(scrutinyRes.data.corpusfundUGPG) ? scrutinyRes.data.corpusfundUGPG : [];
                const safeData = Array.isArray(corpusData) ? corpusData : [];
                setUgCorpusFunds(safeData.filter(item => item.coll_type?.replace(/"/g, '').trim() === 'UG'));
                setPgBeforeCorpus(safeData.filter(item => item.coll_type?.replace(/"/g, '').trim() === 'PG before'));
                setPgAfterCorpus(safeData.filter(item => item.coll_type?.replace(/"/g, '').trim() === 'PG after'));

                const tableRows = buildTableRows(data);
                setTableData(tableRows);
                setInfrastructureDocuments(Array.isArray(scrutinyRes?.data?.documents) ? scrutinyRes.data.documents : []);
            }

            // 2. Get Shifting of Institution Details
            const shiftingRes = await CommonAxiosGet(`${config.url.FAC_URL}getShiftingOfInstDetails/${collCode}`);
            if (shiftingRes?.data?.status === true) {
                const shiftData = shiftingRes.data.data?.[0] || {};
                setShiftingData(shiftData);
            }

            // 3. Get Scrutiny Details for API values
            const apiRes = await CommonAxiosGet(`${config.url.FAC_URL}getScrutinyDetails/${collCode}/shifting`);
            if (apiRes?.data?.status === true) {
                setApiValues(apiRes.data.data?.[0] || {});
            }

            // 4. Get Accommodation Data
            const accomRes = await CommonAxiosGet(`${config.url.FAC_URL}getAccommodationAreaData/${collCode}`);
            if (accomRes?.data?.status === true) {
                // setAccommodationData(accomRes.data.data || []);
            }

            // 5. Get Land/Survey Details
            const surveyRes = await CommonAxiosGet(`${config.url.FAC_URL}getlandDetailsScrutinyShitfing/${collCode}`);
            if (surveyRes?.data?.status === true) {
                setSurveyData(surveyRes.data.data?.[0] || {});
            }

            // 6. Get Leased Data
            const leasedRes = await CommonAxiosGet(`${config.url.FAC_URL}getleasedtls/${collCode}`);
            if (leasedRes?.data?.status === true) {
                setLeasedData(leasedRes.data.leasedtls?.[0] || {});
            }

        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const getInstallmentData = (installmentNo) => {
        const installment = corpusFundInstall?.find((item) => item?.installment_no === installmentNo);
        return installment || {};
    };

    const firstInstallment = getInstallmentData(1);
    const secondInstallment = getInstallmentData(2);
    const thirdInstallment = getInstallmentData(3);

    const formatDate = (dateString) => {
        if (!dateString || dateString === "-") return "-";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "-";
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const buildTableRows = (data) => {
        const formatValue = (val) => {
            if (val === undefined || val === null || val === '') return '—';
            return val;
        };
        return [
            // Section 1: Society & Registration Details
            { sno: '1', section: 'Registration', particulars: 'Transaction Id of Registration and processing fee paid (Rs 30,000)', status: formatValue(apiValues.transaction_id), remarks: '-', isYesNo: false },
            { sno: '2', section: 'Registration', particulars: 'Copy of the resolutions of the Society for shifting of the college', status: formatValue(data.socity_for_shifting), remarks: formatValue(data.socity_for_shifting_remarks), isYesNo: true },
            { sno: '3', section: 'Registration', particulars: 'Society is registered under societies registration act', status: formatValue(data.registration_act), remarks: formatValue(data.registration_act_remarks), isYesNo: true },
            { sno: '4', section: 'Registration', particulars: 'Bye-laws of the Society is enclosed', status: formatValue(data.by_laws), remarks: formatValue(data.by_laws_remarks), isYesNo: true },
            { sno: '5', section: 'Registration', particulars: 'Year of Establishment of the College', status: formatValue(data.year_of_establishment || apiValues.year_of_establishment), remarks: '-', isYesNo: false },
            { sno: '6', section: 'Registration', particulars: 'Permission order for the establishment of the college is enclosed', status: formatValue(data.enclosed_or_not), remarks: formatValue(data.enclosed_or_not_remarks), isYesNo: true },
            { sno: '7', section: 'Registration', particulars: 'Latest University affiliation order (2025-26) is enclosed', status: formatValue(data.atest_university), remarks: formatValue(data.atest_university_remarks), isYesNo: true },
            { sno: '8', section: 'Registration', particulars: 'College is located in', status: apiValues.rural_area === "Yes" ? "Rural/Tribal" : apiValues.rural_area === "No" ? "Urban" : formatValue(data.college_location_type), remarks: '-', isYesNo: false },
            { sno: '9', section: 'Registration', particulars: 'Copy of the last EoP granted is enclosed', status: formatValue(data.eop_granted), remarks: formatValue(data.eop_granted_remarks), isYesNo: true },

            // Section 2: Land Details
            { sno: 'a', section: 'Land', particulars: 'Society has own land as per norms', status: formatValue(data.society_own_land), remarks: formatValue(data.society_own_land_remarks), isYesNo: true },
            { sno: 'b', section: 'Land', particulars: 'Registered ownership of the land deed is produced', status: formatValue(data.ownership_of_the), remarks: formatValue(data.ownership_of_the_remarks), isYesNo: true },
            { sno: 'c', section: 'Land', particulars: `Land Details: Survey No: ${surveyData.survey_no || '-'}, Village: ${surveyData.village_name || '-'}, Mandal: ${surveyData.mandal_name || '-'}, District: ${surveyData.dist_name || '-'}`, status: '-', remarks: '-', isYesNo: false },
            { sno: 'd', section: 'Land', particulars: 'Registered document of the land owned in the name of the Society', status: formatValue(data.owned_name), remarks: formatValue(data.owned_name_remarks), isYesNo: true },
            { sno: 'e', section: 'Land', particulars: 'Own land is provided in the same Mandal', status: formatValue(data.same_mandal), remarks: formatValue(data.same_mandal_remarks), isYesNo: true },
            { sno: 'f', section: 'Land', particulars: 'Distance of the land from the college building (in km)', status: formatValue(data.land_distance_from_cllg || data.land_distance), remarks: formatValue(data.land_distance_remarks), isYesNo: false },
            { sno: 'g', section: 'Land', particulars: 'Sketch plan drawn by licensed surveyor and attested by MRO is produced', status: formatValue(data.licensed_surveyor), remarks: formatValue(data.licensed_surveyor_remarks), isYesNo: true },
            { sno: 'h', section: 'Land', particulars: 'Schedule of property tallying with the sketch plan produced', status: formatValue(data.sketch_plan), remarks: formatValue(data.sketch_plan_remarks), isYesNo: true },

            // Section 3: Building Accommodation
            { sno: 'a', section: 'Building', particulars: 'Nature of Shifting', status: formatValue(data.nature_of_shifting), remarks: formatValue(data.nature_of_shifting_remarks), isYesNo: false },
            { sno: 'b', section: 'Building', particulars: 'College proposed to be shifted within the same Mandal', status: formatValue(data.proposed_to_be_shifted), remarks: formatValue(data.proposed_to_be_shifted_remarks), isYesNo: true },
            { sno: 'c', section: 'Building', particulars: 'New building is permanent and independent with RCC roof', status: formatValue(data.building_is_permanent), remarks: formatValue(data.building_is_permanent_remarks), isYesNo: true },
            { sno: 'd', section: 'Building', particulars: 'College located at least 500 mtrs away from Cinema halls, wine shops, etc.', status: formatValue(data.located_500_mtrs), remarks: formatValue(data.located_500_mtrs_remarks), isYesNo: true },
            { sno: 'e', section: 'Building', particulars: 'Proposed building is leased / own', status: formatValue(data.building_is_leased), remarks: formatValue(data.building_is_leased_remarks), isYesNo: false },

            // Lease details if leased
            ...(data.building_is_leased === 'Leased' ? [
                { sno: 'e1', section: 'Building', particulars: 'If leased, Registered lease document of the building is enclosed', status: formatValue(data.lease_doc_enclosed), remarks: formatValue(data.lease_doc_enclosed_remarks), isYesNo: true },
                { sno: 'e2', section: 'Building', particulars: 'Leased document is registered in the name of the society', status: formatValue(data.lease_in_society_name), remarks: formatValue(data.lease_in_society_name_remarks), isYesNo: true },
                { sno: 'e3', section: 'Building', particulars: 'Year of registration of lease document', status: formatValue(leasedData.year_of_reg), remarks: '-', isYesNo: false },
                { sno: 'e4', section: 'Building', particulars: 'Validity of the lease period', status: formatDate(leasedData.leased_upto), remarks: '-', isYesNo: false },
                { sno: 'e5', section: 'Building', particulars: 'Total years completed in leased building', status: formatValue(leasedData.no_years), remarks: '-', isYesNo: false },
                { sno: 'e6', section: 'Building', particulars: 'Remaining years of lease period', status: formatValue(leasedData.remain_years), remarks: '-', isYesNo: false },
            ] : []),

            // Own details if own
            ...(data.building_is_leased === 'Own' ? [
                { sno: 'e1', section: 'Building', particulars: 'If own, Registered sale deed of the building is uploaded', status: formatValue(data.sale_deed_uploaded), remarks: formatValue(data.sale_deed_uploaded_remarks), isYesNo: true },
                { sno: 'e2', section: 'Building', particulars: 'Sale deed is registered in the name of the Society', status: formatValue(data.sale_deed_society_name), remarks: formatValue(data.sale_deed_society_name_remarks), isYesNo: true },
            ] : []),

            { sno: 'f', section: 'Building', particulars: 'Building plan approved by competent authority', status: formatValue(data.building_accommodation_approved), remarks: formatValue(data.building_accommodation_approved_remarks), isYesNo: true },
            { sno: 'g', section: 'Building', particulars: 'Approved plan drawn by licensed surveyor', status: formatValue(data.drawn_by_licensed), remarks: formatValue(data.drawn_by_licensed_remarks), isYesNo: true },
            { sno: 'h', section: 'Building', particulars: 'Plinth area of the Building (in Sft)', status: formatValue(data.plinth_area), remarks: formatValue(data.plinth_area_remarks), isYesNo: false },
            { sno: 'i', section: 'Building', particulars: 'Construction permission order is uploaded', status: formatValue(data.construction_permission), remarks: formatValue(data.construction_permission_remarks), isYesNo: true },
            { sno: 'j', section: 'Building', particulars: 'Valid Sanitary Certificate is uploaded', status: formatValue(data.sanitary_ertificate), remarks: formatValue(data.sanitary_ertificate_remarks), isYesNo: true },
            { sno: 'k', section: 'Building', particulars: 'Latest Geotagged photographs are uploaded', status: formatValue(data.geotagged_photographs), remarks: formatValue(data.geotagged_photographs_remarks), isYesNo: true },
            { sno: 'l', section: 'Building', particulars: 'Any other Institution running in the same building', status: formatValue(data.is_nstitution_running), remarks: formatValue(data.is_nstitution_running_remarks), isYesNo: true },
            ...(data.is_nstitution_running === 'Yes' ? [
                { sno: 'l1', section: 'Building', particulars: 'NoC from concerned authority is uploaded', status: formatValue(data.authority_to_utilize), remarks: formatValue(data.authority_to_utilize_remarks), isYesNo: true },
            ] : []),
            { sno: 'm', section: 'Building', particulars: 'Building accommodation details as per stipulated norms', status: formatValue(data.existing_building), remarks: formatValue(data.existing_building_remarks), isYesNo: true },

            // Section 4: Parking Area
            { sno: 'a', section: 'Parking', particulars: 'Parking area is available in the same premises', status: formatValue(data.parking_available), remarks: formatValue(data.parking_available_remarks), isYesNo: true },
            ...(data.parking_available === 'Yes' ? [
                { sno: 'b', section: 'Parking', particulars: '20% of total built up area provided for Parking', status: formatValue(data.parking_area20percent), remarks: formatValue(data.parking_area20percent_remarks), isYesNo: true },
            ] : []),

            // Section 5: Playground & Fire Safety
            { sno: 'a', section: 'Playground', particulars: 'Playground facility available in the same premises', status: formatValue(data.playground_available), remarks: formatValue(data.playground_available_remarks), isYesNo: true },
            ...(data.playground_available === 'Yes' ? [
                { sno: 'b', section: 'Playground', particulars: 'Extent of playground facility available (sft)', status: formatValue(data.playground_extent), remarks: formatValue(data.playground_extent_remarks), isYesNo: false },
            ] : []),
            ...(data.playground_available === 'No' ? [
                { sno: 'c', section: 'Playground', particulars: 'Alternative arrangement for playground within 5 kms', status: formatValue(data.alternative_playground), remarks: formatValue(data.alternative_arrangement_remarks), isYesNo: true },
            ] : []),
            ...(data.alternative_playground === 'Yes' ? [
                { sno: 'd', section: 'Playground', particulars: 'MoU for alternative facility is produced', status: formatValue(data.playground_mou), remarks: formatValue(data.playground_mou_remarks), isYesNo: true },
            ] : []),
            { sno: 'a', section: 'Safety', particulars: 'Valid fire safety certificate', status: formatValue(data.parking_exempted_cases), remarks: formatValue(data.parking_exempted_cases_remarks), isYesNo: true },
            { sno: 'b', section: 'Safety', particulars: 'Latest affidavit for exempted cases is produced', status: formatValue(data.latest_affidavit), remarks: formatValue(data.latest_affidavit_remarks), isYesNo: true },

            // Section 6: Corpus Fund
            { sno: 'a', section: 'Corpus Fund', particulars: 'College exempted from paying Corpus Fund', status: formatValue(data.corpus_fund), remarks: formatValue(data.corpus_fund_remarks), isYesNo: true },
            ...(data.corpus_fund === 'Yes' ? [
                { sno: 'b', section: 'Corpus Fund', particulars: 'Rural/tribal area certificate issued by MRO is produced', status: formatValue(data.certificate_issued), remarks: formatValue(data.certificate_issued_remarks), isYesNo: true },
            ] : []),

            // Section 7: Infrastructure
            { sno: 'a', section: 'Infrastructure', particulars: 'Lab equipment provided for all subjects', status: formatValue(data.lab_equipment_provided), remarks: formatValue(data.lab_equipment_provided_remarks), isYesNo: true },
            ...(data.lab_equipment_provided === 'No' ? [
                { sno: 'a1', section: 'Infrastructure', particulars: 'Subjects that lack equipment', status: formatValue(data.lab_lack_equipments), remarks: formatValue(data.lab_lack_equipments_remarks), isYesNo: false },
            ] : []),
            { sno: 'b', section: 'Infrastructure', particulars: 'Library books provided for all subjects', status: formatValue(data.library_books_provided), remarks: formatValue(data.library_books_provided_remarks), isYesNo: true },
            ...(data.library_books_provided === 'No' ? [
                { sno: 'b1', section: 'Infrastructure', particulars: 'Subjects that lack books', status: formatValue(data.library_lack_equipments), remarks: formatValue(data.library_lack_equipments_remarks), isYesNo: false },
            ] : []),
            { sno: 'c', section: 'Infrastructure', particulars: 'Adequate teaching and supporting staff as per norms', status: formatValue(data.staff_ugc_norms), remarks: formatValue(data.staff_ugc_norms_remarks), isYesNo: true },
            ...(data.staff_ugc_norms === 'No' ? [
                { sno: 'c1', section: 'Infrastructure', particulars: 'Staff deficiencies', status: formatValue(data.staff_teaching_deficiencies), remarks: formatValue(data.staff_teaching_deficiencies_remarks), isYesNo: false },
            ] : []),
            { sno: 'd', section: 'Infrastructure', particulars: 'Scholarship details as per Annexure-III', status: formatValue(data.staff_as_per_annexure), remarks: formatValue(data.staff_as_per_annexure_remarks), isYesNo: true },
            { sno: 'e', section: 'Infrastructure', particulars: 'College secured University ranks', status: formatValue(data.staff_university_rank), remarks: formatValue(data.staff_university_rank_remarks), isYesNo: true },
            { sno: 'f', section: 'Infrastructure', particulars: 'College conducted extension activities', status: formatValue(data.staff_extension_activities), remarks: formatValue(data.staff_extension_activities_remarks), isYesNo: true },
            { sno: 'g', section: 'Infrastructure', particulars: 'College has functional website', status: formatValue(data.staff_functional_website), remarks: formatValue(data.staff_functional_website_remarks), isYesNo: true },
        ];
    };

    // const handleDownloadPDF = () => {
    //     const url = `${config.url.FAC_URL}getScrutinyDetailspdf/${collCode}/${nocType || 'shifting'}`;
    //     CommonAxiosGet(url).then((res) => {
    //         if (res?.data?.pdf) {
    //             downloadBase64Pdf(res.data.pdf, `${collCode}_shifting_scrutiny_report.pdf`);
    //         }
    //     });
    // };
    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
        @media print {
            .btn, .card-footer, .no-print {
                display: none !important;
            }
            .card {
                border: none !important;
                box-shadow: none !important;
            }
            .card-header {
                background-color: #28a745 !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
            .bg-light {
                background-color: #e9ecef !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
            .table-primary th {
                background-color: #0d6efd !important;
                color: white !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
            .table-danger th {
                background-color: #dc3545 !important;
                color: white !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
            .badge.bg-success {
                background-color: #28a745 !important;
                color: white !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
            .badge.bg-danger {
                background-color: #dc3545 !important;
                color: white !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
            .text-success {
                color: #28a745 !important;
            }
            .text-danger {
                color: #dc3545 !important;
            }
            h5 {
                color: #0d6efd !important;
            }
            .bg-light {
                background-color: #e9ecef !important;
            }
            /* Ensure all table headers have color */
            thead th {
                background-color: #0d6efd !important;
                color: white !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
        }
    `;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);
    const handleDownloadPDF = () => {
        const originalTitle = document.title;
        const printContent = document.querySelector('.card').cloneNode(true);

        // Remove the button footer from print
        const footer = printContent.querySelector('.card-footer');
        if (footer) footer.remove();

        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
        <!DOCTYPE html>
        <html>
            <head>
                <title>Shifting Scrutiny Report - ${collCode}</title>
                <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
                <style>
                    body { 
                        padding: 20px; 
                        font-family: Arial, sans-serif; 
                    }
                    .card {
                        border: none !important;
                        box-shadow: none !important;
                    }
                    .card-header {
                        background-color: #28a745 !important;
                        color: white !important;
                        padding: 15px;
                        border-radius: 5px;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                    .card-header h4 {
                        color: white !important;
                        margin: 0 !important;
                    }
                    .bg-light {
                        background-color: #e9ecef !important;
                        padding: 10px;
                        border-radius: 5px;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                    .bg-light h5 {
                        margin: 0 !important;
                    }
                    table {
                        width: 100%;
                        border-collapse: collapse;
                        margin-bottom: 20px;
                    }
                    th, td {
                        border: 1px solid #ddd;
                        padding: 8px;
                    }
                    thead th {
                        background-color: #5976a3 !important;
                        color: white !important;
                        text-align: center;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                    .table-primary th {
                        background-color: #2e466b !important;
                        color: white !important;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                    .table-danger th {
                        background-color: #dc3545 !important;
                        color: white !important;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                    .badge {
                        padding: 3px 8px;
                        border-radius: 4px;
                        font-weight: bold;
                    }
                    .badge.bg-success {
                        background-color: #28a745 !important;
                        color: white !important;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                    .badge.bg-danger {
                        background-color: #dc3545 !important;
                        color: white !important;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                    .text-success {
                        color: #28a745 !important;
                        font-weight: bold !important;
                    }
                    .text-danger {
                        color: #dc3545 !important;
                        font-weight: bold !important;
                    }
                    .text-center {
                        text-align: center;
                    }
                    .fw-bold {
                        font-weight: bold;
                    }
                    .mt-4 {
                        margin-top: 20px;
                    }
                    .mb-3 {
                        margin-bottom: 10px;
                    }
                    h5 {
                        color: #0d6efd !important;
                        font-weight: bold !important;
                    }
                </style>
            </head>
            <body>
                ${printContent.outerHTML}
            </body>
        </html>
    `);
        printWindow.document.close();
        printWindow.print();
        printWindow.close();
    };
    if (loading) {
        return <div className="text-center p-5">Loading...</div>;
    }

    const sections = {};
    tableData.forEach(row => {
        if (!sections[row.section]) sections[row.section] = [];
        sections[row.section].push(row);
    });

    const getStatusBadge = (status, isYesNo) => {
        if (!isYesNo) return <span>{status}</span>;
        if (status === 'Yes') return <span className="badge bg-success">Yes</span>;
        if (status === 'No') return <span className="badge bg-danger">No</span>;
        return <span>{status}</span>;
    };

    return (
        <Container fluid className="py-4">
            <Card className="shadow-sm">
                <Card.Header className="bg-success text-white">
                    <h4 className="mb-0">Shifting Scrutiny Report - {scrutinyData?.inst_name || apiValues.inst_name || 'College'} ({collCode})</h4>
                    <small>Academic Year 2026-27</small>
                </Card.Header>
                <Card.Body>
                    {/* Institution Details */}
                    <h5 className="mb-3">Institution Details</h5>
                    <Table bordered responsive size="sm">
                        <tbody>
                            <tr><th style={{ width: '30%' }}>Name of the Society & Address</th><td>{apiValues.society_name || '-'} - {apiValues.mandal_name || '-'}</td></tr>
                            <tr><th>Name and address of the Existing Degree College</th><td>{apiValues.inst_name || '-'}</td></tr>
                            <tr><th>Name & New Address Proposed to Shift</th><td>Mandal: {shiftingData?.new_mandal || shiftingData?.mandal_name || '-'}<br />District: {shiftingData?.new_district || '-'}<br />Pincode: {shiftingData?.new_pincode || '-'}<br />Address: {shiftingData?.address_ofnew_location || '-'}</td></tr>
                        </tbody>
                    </Table>

                    {/* Main Tabular Data */}
                    {Object.keys(sections).map(section => (
                        <div key={section} className="mt-4">
                            {/* <h5 className="bg-light p-2 rounded">{section} Details</h5> */}
                            <h5 className="bg-light p-2 rounded">
                                {section === 'Registration' ? '1-9. Registration & Basic Details' :
                                    section === 'Land' ? '10. Land' :
                                        section === 'Building' ? '11. New Building Accommodation' :
                                            section === 'Parking' ? '12. Parking Area' :
                                                section === 'Playground' ? '13. Playground' :
                                                    section === 'Safety' ? '14. Fire Safety' :
                                                        section === 'Corpus Fund' ? '15. Corpus Fund' :
                                                            section === 'Infrastructure' ? '16. Infrastructure & Academic Facilities' :
                                                                `${section} Details`}
                            </h5>
                            <Table bordered responsive hover size="sm">
                                <thead className="table-primary">
                                    <tr><th style={{ width: '8%' }}>S.No</th><th style={{ width: '52%' }}>Particulars</th><th style={{ width: '20%' }}>Status</th><th style={{ width: '20%' }}>Remarks</th></tr>
                                </thead>
                                <tbody>
                                    {sections[section].map((row, idx) => (
                                        <tr key={idx}>
                                            <td className="text-center">{row.sno}</td>
                                            <td>{row.particulars}</td>
                                            <td className={row.isYesNo ? (row.status === 'Yes' ? 'text-success fw-bold' : row.status === 'No' ? 'text-danger fw-bold' : '') : ''}>
                                                {getStatusBadge(row.status, row.isYesNo)}
                                            </td>
                                            <td>{row.remarks}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    ))}

                    {/* UG Programmes Table */}
                    {ugCourses.length > 0 && (
                        <div className="mt-4">
                            <h5 className="bg-light p-2 rounded">UG Programmes Details</h5>
                            <Table bordered responsive size="sm">
                                <thead className="table-primary"><tr><th>S.No</th><th>Type of UG Programme</th><th>Total Programmes</th><th>Sanctioned Intake</th></tr></thead>
                                <tbody>
                                    {ugCourses.map((item, idx) => (
                                        <tr key={idx}><td className="text-center">{idx + 1}</td><td>{item.course_cat_name}</td><td className="text-center">{item.count}</td><td className="text-center">{item.sum}</td></tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}

                    {/* PG Programmes Table */}
                    {pgCourses.length > 0 && (
                        <div className="mt-4">
                            <h5 className="bg-light p-2 rounded">PG Programmes Details</h5>
                            <Table bordered responsive size="sm">
                                <thead className="table-primary"><tr><th>S.No</th><th>Type of PG Programme</th><th>Total Programmes</th><th>Sanctioned Intake</th></tr></thead>
                                <tbody>
                                    {pgCourses.map((item, idx) => (
                                        <tr key={idx}><td className="text-center">{idx + 1}</td><td>{item.course_cat_name}</td><td className="text-center">{item.count}</td><td className="text-center">{item.sum}</td></tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}

                    {/* Corpus Fund Installments Table */}
                    {corpusFundInstall.length > 0 && (
                        <div className="mt-4">
                            <h5 className="bg-light p-2 rounded">Corpus Fund Installments (Colleges established before 2021-22)</h5>
                            <Table bordered responsive size="sm">
                                <thead className="table-primary"><tr><th>Required Information</th><th>First Installment</th><th>Second Installment</th><th>Third Installment</th></tr></thead>
                                <tbody>
                                    <tr><td>Amount</td><td>{firstInstallment.amount || '-'}</td><td>{secondInstallment.amount || '-'}</td><td>{thirdInstallment.amount || '-'}</td></tr>
                                    <tr><td>Period (from - to)</td><td>{firstInstallment.from_date ? `${firstInstallment.from_date} - ${firstInstallment.to_date}` : '-'}</td><td>{secondInstallment.from_date ? `${secondInstallment.from_date} - ${secondInstallment.to_date}` : '-'}</td><td>{thirdInstallment.from_date ? `${thirdInstallment.from_date} - ${thirdInstallment.to_date}` : '-'}</td></tr>
                                    <tr><td>Date of FDR</td><td>{firstInstallment.date_of_fdr || '-'}</td><td>{secondInstallment.date_of_fdr || '-'}</td><td>{thirdInstallment.date_of_fdr || '-'}</td></tr>
                                    <tr><td>Name & address of the Issuing Bank</td><td>{firstInstallment.bank_address || '-'}</td><td>{secondInstallment.bank_address || '-'}</td><td>{thirdInstallment.bank_address || '-'}</td></tr>
                                    <tr><td>IFSC CODE</td><td>{firstInstallment.ifsc || '-'}</td><td>{secondInstallment.ifsc || '-'}</td><td>{thirdInstallment.ifsc || '-'}</td></tr>
                                    <tr><td>Date of maturity</td><td>{firstInstallment.date_of_maturity || '-'}</td><td>{secondInstallment.date_of_maturity || '-'}</td><td>{thirdInstallment.date_of_maturity || '-'}</td></tr>
                                    <tr><td>Date of renewal</td><td>{firstInstallment.date_of_renewal || '-'}</td><td>{secondInstallment.date_of_renewal || '-'}</td><td>{thirdInstallment.date_of_renewal || '-'}</td></tr>
                                </tbody>
                            </Table>
                        </div>
                    )}

                    {/* UG Corpus Funds Table */}
                    {ugCorpusFunds.length > 0 && (
                        <div className="mt-4">
                            <h5 className="bg-light p-2 rounded">Corpus Fund for UG Programmes (sanctioned after 2021-22)</h5>
                            <Table bordered responsive size="sm">
                                <thead className="table-primary"><tr><th>S.No</th><th>Programme</th><th>Amount</th><th>Period</th><th>FDR No.</th><th>Date</th></tr></thead>
                                <tbody>
                                    {ugCorpusFunds.map((item, idx) => (
                                        <tr key={idx}><td className="text-center">{idx + 1}</td><td>{item.course_name}</td><td>₹{item.amount}</td><td>{item.period_from} to {item.period_to}</td><td>{item.fdr_bank_number}</td><td>{item.corpus_date}</td></tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}

                    {/* PG Before Corpus Funds Table */}
                    {pgBeforeCorpus.length > 0 && (
                        <div className="mt-4">
                            <h5 className="bg-light p-2 rounded">Corpus Fund for PG Programmes (sanctioned before 2021-22)</h5>
                            <Table bordered responsive size="sm">
                                <thead className="table-primary"><tr><th>S.No</th><th>Programme</th><th>Amount</th><th>Period</th><th>FDR No.</th><th>Date</th></tr></thead>
                                <tbody>
                                    {pgBeforeCorpus.map((item, idx) => (
                                        <tr key={idx}><td className="text-center">{idx + 1}</td><td>{item.course_name}</td><td>₹{item.amount}</td><td>{item.period_from} to {item.period_to}</td><td>{item.fdr_bank_number}</td><td>{item.corpus_date}</td></tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}

                    {/* PG After Corpus Funds Table */}
                    {pgAfterCorpus.length > 0 && (
                        <div className="mt-4">
                            <h5 className="bg-light p-2 rounded">Corpus Fund for PG Programmes (sanctioned after 2021-22)</h5>
                            <Table bordered responsive size="sm">
                                <thead className="table-primary"><tr><th>S.No</th><th>Programme</th><th>Amount</th><th>Period</th><th>FDR No.</th><th>Date</th></tr></thead>
                                <tbody>
                                    {pgAfterCorpus.map((item, idx) => (
                                        <tr key={idx}><td className="text-center">{idx + 1}</td><td>{item.course_name}</td><td>₹{item.amount}</td><td>{item.period_from} to {item.period_to}</td><td>{item.fdr_bank_number}</td><td>{item.corpus_date}</td></tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}

                    {/* Accommodation Table */}
                    {accommodationData.length > 0 && (
                        <div className="mt-4">
                            <h5 className="bg-light p-2 rounded">Accommodation Details</h5>
                            <Table bordered responsive size="sm">
                                <thead className="table-primary"><tr><th>S.No</th><th>Type of Room</th><th>Rooms Required</th><th>Area Required (sft)</th><th>Rooms Provided</th><th>Sufficient</th><th>Remarks</th></tr></thead>
                                <tbody>
                                    {accommodationData?.map((item, idx) => (
                                        <tr key={idx}>
                                            <td className="text-center">{idx + 1}</td>
                                            <td>{item.particular_name || '-'}</td>
                                            <td className="text-center">{item.no_of_rooms || '-'}</td>
                                            <td className="text-center">{item.total_area || '-'}</td>
                                            <td className="text-center">{item.no_of_rooms || '-'}</td>
                                            <td className="text-center">
                                                <span
                                                    className={`status-text ${item.sufficient_as_per_norms === 'Yes'
                                                        ? 'text-success'
                                                        : 'text-danger'
                                                        }`}
                                                >
                                                    {item.sufficient_as_per_norms || '-'}
                                                </span>
                                            </td>                                            <td>{item.remarks || '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}

                    {infrastructureDocuments.length > 0 && (
                        <div className="mt-4">
                            <h5 className="bg-light p-2 rounded">Phase 2 - Physical Infrastructure Verification</h5>
                            <Table bordered responsive size="sm">
                                <thead className="table-primary">
                                    <tr>
                                        <th style={{ width: '8%' }}>S.No</th>
                                        <th style={{ width: '52%' }}>Infrastructure Item</th>
                                        <th style={{ width: '20%' }}>Status</th>
                                        <th style={{ width: '20%' }}>Document</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {infrastructureDocuments.map((doc, idx) => (
                                        <tr key={idx}>
                                            <td className="text-center">{idx + 1}</td>
                                            <td>{doc.doc_type || '-'}</td>
                                            <td className={doc.doc_norms === 'Yes' ? 'text-success fw-bold' : 'text-danger fw-bold'}>
                                                <span className={doc.doc_norms === 'Yes' ? 'badge bg-success' : 'badge bg-danger'}>
                                                    {doc.doc_norms === 'Yes' ? 'Yes' : 'No'}
                                                </span>
                                            </td>
                                            <td>
                                                {doc.doc_upload ? (
                                                    doc.doc_type === "Video Upload" ? (
                                                        <a href={doc.doc_upload} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary">
                                                            <i className="fa fa-play"></i> Watch Video
                                                        </a>
                                                    ) : (
                                                        <button
                                                            className="btn btn-sm btn-outline-primary text-center"
                                                            onClick={() => viewImage(doc.doc_upload)}
                                                        >
                                                            <i className="fa fa-eye text-center"></i> View
                                                        </button>
                                                    )
                                                ) : '-'}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                    {/* Final Remarks & Status */}
                    <div className="mt-4">
                        <h5>Final Remarks</h5>
                        <p>{scrutinyData?.final_remarks || '—'}</p>
                        <h5>Final Status</h5>
                        <p className={scrutinyData?.final_status === 'DeficiencyIdentified' ? 'text-danger fw-bold' : 'text-success fw-bold'}>
                            {scrutinyData?.final_status === 'DeficiencyIdentified' ? 'Deficiencies Identified' : scrutinyData?.final_status === 'NoDeficienciesIdentified' ? 'No Deficiencies Identified' : scrutinyData?.final_status || '—'}
                        </p>
                    </div>


                    {Array.isArray(deficiencies) && deficiencies.length > 0 && (scrutinyData?.final_status === 'DeficiencyIdentified' || scrutinyData?.final_status === 'May not be permitted' || scrutinyData?.final_status === "Conditionally Permitted") && (

                        <div className="mt-4">
                            {/* <h5 className="text-danger">Deficiencies Identified</h5> */}
                            <Table bordered responsive size="sm">
                                <thead className="table-danger"><tr><th style={{ width: '10%' }}>S.No</th><th style={{ width: '90%' }}>Deficiency Remarks</th></tr></thead>
                                <tbody>
                                    {deficiencies?.map((item, idx) => (
                                        <tr key={idx}><td className="text-center">{idx + 1}</td><td>{item.remarks || item.deficiency_description || '-'}</td></tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Card.Body>
                <Card.Footer className="bg-light text-end">
                    <Button variant="success" onClick={handleDownloadPDF}><FaDownload className="me-2" /> Download PDF Report</Button>
                </Card.Footer>
            </Card>
            <div className="text-center text-muted small mt-3">
                <div>College Code: {collCode}</div>
                {/* <div>Inspected By: {scrutinyData?.user_name || '-'} | Date of Inspection: {scrutinyData?.inspection_update_time ? new Date(scrutinyData.inspection_update_time).toLocaleDateString('en-GB') : '-'}</div> */}
            </div>
        </Container>
    );
}